"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = (dispatch, authenticationManager) => ({
  async authenticationFailureInterceptor(error, pass401) {
    if (!pass401 && error.response && error.response.status === 401) {
      await dispatch('authentication/clearToken', null, {
        root: true
      }); // eslint-disable-next-line no-undef

      window.location.replace(`/?tokenExpired=true&from=${window.location.pathname}`);
      return;
    }

    throw error;
  },

  async bearerTokenInterceptor(config) {
    await authenticationManager.executeSilentRefreshToken(5 * 60 * 1000); // eslint-disable-next-line no-param-reassign

    config.headers = Object.assign({}, config.headers, {
      Authorization: authenticationManager.getBearer()
    });
    return config;
  },

  wrapper(construct, fieldName, pass401 = false) {
    return state => {
      if (state[fieldName] === null) {
        // eslint-disable-next-line new-cap
        const client = new construct({
          baseURL: process.env.VUE_APP_API_GATEWAY_URL,
          timeout: parseInt(process.env.VUE_APP_HTTP_REQUEST_TIMEOUT, 10)
        });
        client.httpClient.interceptors.response.use(undefined, error => this.authenticationFailureInterceptor(error, pass401));
        client.httpClient.interceptors.request.use(config => this.bearerTokenInterceptor(config)); // eslint-disable-next-line no-param-reassign

        state[fieldName] = client;
      }

      return state[fieldName];
    };
  }

});

exports.default = _default;